import Axios from "axios";

export class SubscriptionService {
    public static async createSubscription(
        payload: { id: string; orderID: string },
        token: string
    ): Promise<{}> {
        const uri = `/api/webhooks/subscription`;
        const response = await Axios.post(uri, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    }

    public static async cancelSubscription(id: string, token: string) {
        const uri: string = "/api/webhooks/subscription";
        const response = await Axios.delete(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data: {
                id,
            },
        });
        return response.data;
    }
}
